import { algoliasearch } from 'algoliasearch'
import { global } from './constants'
import { fetchResponse } from '../../controllers/shared/utils/fetch_data'

const useAlgoliaSearch = () => {
  if (global.isTest) {
    const mockClient = {
      searchSingleIndex: async ({ searchParams: { query } }, headers) => {
        let hits = []
        const response = await fetchResponse(`/admin/org/people/algolia_search?query=${query}`)

        if (response.status === 200) {
          hits = await response.json()
        }

        return { hits, queryID: 'someheaders' }
      }
    }

    return {
      client: mockClient
    }
  }

  const algoliaClient = algoliasearch(global.applicationId, global.searchKey, {
    headers: { 'X-Algolia-UserToken': global.userId }
  })

  return { client: algoliaClient }
}

export default useAlgoliaSearch
